// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.5 7H6.5V9H17.5V7H15.5V2.5H21.5V7H19.5V17H21.5V21.5H15.5V17H17.5V15H6.5V17H8.5V21.5H2.5V17H4.5V7H2.5V2.5H8.5V7ZM6.5 13H17.5V11H6.5V13Z"}}]};

const PlantumlFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'plantuml-filled',
    ref,
    icon: element,
  },
));

PlantumlFilledIcon.displayName = 'PlantumlFilledIcon';

export default PlantumlFilledIcon;
